import React, { FC } from 'react';
import { css } from '@emotion/css';

interface SliderRoundedArrowsProps {
  prev: () => void;
  next: () => void;
  disablePrev: boolean;
  disableNext: boolean;
}

const SliderRoundedArrows: FC<SliderRoundedArrowsProps> = (props) => {
  const { prev, next, disablePrev, disableNext } = props;

  return (
    <div className={styles.root}>
      <button className={styles.button} onClick={prev} disabled={disablePrev} />
      <button className={styles.button} onClick={next} disabled={disableNext} />
    </div>
  );
};

const styles = {
  root: css`
    display: flex;
    margin: auto 0 0 auto;
    overflow: hidden;
  `,
  button: css`
    position: absolute;
    left: 12px;
    top: 45%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 45px;
    outline: none;
    background: #ffffff;
    border: 1px solid #979797;
    border-radius: 50%;
    cursor: pointer;

    &:disabled {
      display: none;
    }

    &:last-child {
      left: auto;
      right: 12px;
      top: 45%;
    }

    &:before {
      height: 19px;
      width: 11px;
      content: '';
      background: url("data:image/svg+xml,%3Csvg width='11' height='19' viewBox='0 0 11 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.32107 18.0436L0.366121 10.0886C-0.122035 9.60045 -0.122035 8.80899 0.36612 8.32083L8.32107 0.365883C8.80923 -0.122272 9.60068 -0.122272 10.0888 0.365883C10.577 0.854038 10.577 1.64549 10.0888 2.13365L3.01777 9.20472L10.0888 16.2758C10.577 16.7639 10.577 17.5554 10.0888 18.0436C9.60068 18.5317 8.80923 18.5317 8.32107 18.0436Z' fill='gray'/%3E%3C/svg%3E%0A")
        center no-repeat;
    }

    &:last-child:before {
      transform: rotate(180deg);
    }
  `,
};

export default SliderRoundedArrows;
